module.exports = __webpack_public_path__ + "media/images/sp/specials/common/benefit/benefit_couple_photo-aa5f8352a438e60940d921a318660f3a.jpg";